<template lang="pug">
  v-dialog(offset-y left scrollable :close-on-content-click="false" min-width="320px" max-width="400px" v-model="showing").text-center
    template(v-slot:activator="{ on }")
      v-btn(icon x-small @click="toggle").assign-leader__open-btn
        v-icon mdi-account-voice
    v-card
      v-card-title
        span Assign Course Leader
        
      v-card-text
        v-autocomplete(
          label='Course Leaders'
          v-model="selectedValue"
          :loading="loading"
          :items="leaders"
          :menu-props="{contentClass: 'menu-with-scroll-visible'}"
          item-text="name"
          item-value="ID"
          multiple
          ref="select"
        )
          template(v-slot:prepend-item)
            select-close-btn(@click.native="closeSelect($refs.select)")

      v-divider
      
      v-card-actions
        v-btn(
          @click="toggle"
          outlined
          color="primary"
        ).mr-1 Cancel
        v-btn(
          @click="submit"
          :loading="processing"
          color="primary"
          data-test="submit-btn"
        ) Assign
</template>

<script>
import Svc from "../../course_leaders/core/courseLeadersService"
import errorsMixin from '@/mixins/errors.mixin'
import AutocompleteMixin from "@/app/admin/mixins/autocomplete.mixin"

export default {
  props: {
    course: Object,
    processing: Boolean
  },

  mixins: [AutocompleteMixin, errorsMixin],
  
  data: () => ({
    svc: new Svc(),
    showing: false,
    loading: false,
    leaders: [],
    selectedValue: []
  }),
  
  mounted() {
    this.loadData();
    this.setDefault();
  },
  
  watch: {
    course() {
      this.setDefault();
    },
    showing() {
      this.setDefault();
    }
  },

  methods: {
    async loadData() {
      try {
        this.loading = true;
        let { results } = await this.svc.listCached({is_archived: false});
        this.leaders = results.sort((a, b) => (a.ID > b.ID) ? 1 : -1);
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }
    },
    
    setDefault() {
      if( this.course ) {
        this.selectedValue = this.course.leaders.map( ({id}) => id );
      }
    },
    
    toggle() {
      this.showing = !this.showing
    },
    
    submit() {
      this.$emit('assign', {ID: this.course.ID, leaders: this.selectedValue});
      this.course.leaders = this.leaders
        .filter(({ID}) => this.selectedValue.includes(ID))
        .map( item => item.getApiData() );
      this.toggle()
    },
  },
  
  beforeDestroy() {
    this.svc.clearCache()
  },

  components: {
    selectCloseBtn: () => import('@/app/admin/components/SelectCloseBtn.vue'),
  }
}
</script>

<style lang="scss" scoped>
.assign-leader {
  &__open-btn {
    height: 20px;
    width: 20px;
    &::v-deep {
      .v-icon {
        font-size: 16px;
        width: 16px;
        height: 16px;
      }
    }
  }
}
</style>
